import fetchAPI from '../fetchAPI';

export const callDeleteLookup = async (
  id: string
): Promise<iResponse<{ code: number; message: string }>> => {
  const response: iResponse<{ code: number; message: string }> = await fetchAPI({
    method: `DELETE`,
    route: `lookup`,
    id
  });
  return response;
};

export default callDeleteLookup;
